export const PATHS = {
  root: '/',
  myCourses: '/my-courses',
  classroom: '/classroom',
  guidedPractice: '/guided-practice',
  maintenance: '/maintenance',
  loginWithToken: '/loginWithToken',
  loginBypass: '/LoginBypass',
  courseCode: '/courseCode',
  mygoal: '/mygoal',
  mypath: '/mypath',
  login: '/login',
  logout: '/logout',
  loginLoading: '/login-loading',
  loginSuccess: '/login-success',
  healthCheck: '/health-check',
};
